import request from '@/utils/request'


// 查询店铺和用户积分列表
export function listUserScore(query) {
  return request({
    url: '/shop/user/score/list',
    method: 'get',
    params: query
  })
}
export function listUnBindUser(query) {
  return request({
    url: '/shop/user/score/listUnBindUser',
    method: 'get',
    params: query
  })
}

// 查询店铺和用户积分分页
export function pageUserScore(query) {
  return request({
    url: '/shop/user/score/page',
    method: 'get',
    params: query
  })
}

// 查询店铺和用户积分详细
export function getUserScore(data) {
  return request({
    url: '/shop/user/score/detail',
    method: 'get',
    params: data
  })
}

// 新增店铺和用户积分
export function addUserScore(data) {
  return request({
    url: '/shop/user/score/add',
    method: 'post',
    data: data
  })
}

// 修改店铺和用户积分
export function updateUserScore(data) {
  return request({
    url: '/shop/user/score/edit',
    method: 'post',
    data: data
  })
}

// 删除店铺和用户积分
export function delUserScore(data) {
  return request({
    url: '/shop/user/score/delete',
    method: 'post',
    data: data
  })
}
